import { Component, AfterViewInit, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Preferences } from '@capacitor/preferences';
import { LocalStorageService } from './services/local-storage.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements AfterViewInit, OnInit {
  title = 'p2p-energy-trading-front';
  constructor(
    private router: Router,
    private localStorageService: LocalStorageService
  ) {}

  async ngOnInit() {
    await this.checkFirstLaunch();
  }
  
  ngAfterViewInit(): void {
    document.body.classList.add('loaded');
  }

  async checkFirstLaunch() {
    const { value } = await Preferences.get({ key: 'hasLaunched' });
    const currentUrl = this.router.url;
  
    const sessionToken = await this.localStorageService.getToken();
  
    const isPublicUtilityRoute = currentUrl.startsWith('/utility-welcome') || currentUrl.startsWith('/utility-login');
    const isPartnerRoute = currentUrl.startsWith('/partner');
    if ((!value || sessionToken === "") && !currentUrl.startsWith('/admin-dash') && !isPublicUtilityRoute && !isPartnerRoute) {
      this.router.navigateByUrl('/welcome');
      await Preferences.set({ key: 'hasLaunched', value: 'true' });
    }
  }
}
